<script>
  import Caja from "../../UI/Caja.svelte";
  import Subtitulo from "../../UI/Subtitulo.svelte";
  import Barra from "../../UI/Progreso/Barra.svelte";
  import Tabla from "./Tabla.svelte";
  import Boton from "../../UI/Boton.svelte";
  import Icono from "../../UI/Icono.svelte";

  import {createEventDispatcher} from 'svelte';
  import Incidencias from "../../Marcajes/Incidencias.svelte";

  const dispatch = createEventDispatcher();

  export let dia;
  export let mensajeSiNoHayDias;
</script>

<style>
    .boton-e-incidencias {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
</style>

<Caja>
    <div slot="titulo">
        <Subtitulo>Detalle de los marcajes</Subtitulo>
    </div>

    <div class="barra">
        <Barra {dia}/>
    </div>

    <div class="boton-e-incidencias">
        <Boton on:click={() => dispatch('nuevo-marcaje')} tipo="ok">
            <Icono tamano={30} margen>add</Icono>
            Nuevo marcaje
        </Boton>

        <div class="incidencias">
            <Incidencias marcaje={dia}/>
        </div>
    </div>

    <Tabla on:ver-informacion on:editar on:incorrecto {dia} {mensajeSiNoHayDias}/>

</Caja>